import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { DecodeTemplateStatus, TemplatePtAPI, type DecodeTemplateListQuery } from "@repo/api";
import { templateKeys } from "@repo/query";

/** 解码历史里有处理中的记录时，每 30s 静默刷新一次 */
const PROCESSING_POLL_INTERVAL = 30_000;

/** 模板溯源剩余配额（发货数 / 解码数） */
export function useDecodeQuota(enabled: boolean) {
  return useQuery({
    queryKey: templateKeys.decodeQuota(),
    queryFn: () => TemplatePtAPI.getQuotaRemaining().then((r) => r.data),
    enabled,
  });
}

/**
 * 解码历史（页码分页）。筛选条件进 key；翻页保留上一页；
 * 当前页存在「处理中」记录时自动轮询，全部完成后停止。
 */
export function useDecodeHistory(params: DecodeTemplateListQuery, enabled: boolean) {
  return useQuery({
    queryKey: templateKeys.decodeHistory(params as Record<string, unknown>),
    queryFn: () => TemplatePtAPI.getDecodeTemplateList(params).then((r) => r.data),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: (query) => {
      const content = query.state.data?.content ?? [];
      return content.some((item) => item.status === DecodeTemplateStatus.Processing)
        ? PROCESSING_POLL_INTERVAL
        : false;
    },
  });
}

/** 提交解码成功后调用：配额与历史列表一起失效 */
export function useInvalidateTrace() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: templateKeys.decodeQuota() });
    void queryClient.invalidateQueries({ queryKey: [...templateKeys.all, "decode-history"] });
  };
}
